// i18n - Multi-language support for BELLAJA Electric
import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Header / Nav
    nav_services: 'Services',
    nav_gallery: 'Gallery',
    nav_pricing: 'Pricing',
    nav_contact: 'Contact',
    nav_team: 'Team',
    nav_customer_login: 'Customer Login',
    nav_get_quote: 'Get Quote',
    // Landing
    hero_title: 'Electrical & Security Systems',
    hero_subtitle: 'Professional electrical, CCTV, and security solutions for residential & commercial properties in New York City.',
    hero_cta: 'Get Free Estimate',
    hero_cta2: 'Our Services',
    hero_badge: 'NYC DOB Certified',
    hero_trusted: 'Trusted by 500+ NYC Properties',
    // Services Section
    section_services: 'Our Services',
    section_services_sub: 'Complete electrical and security solutions for every need',
    // Gallery
    section_gallery: 'Our Work',
    section_gallery_sub: 'Browse our portfolio of completed projects',
    view_gallery: 'View Gallery',
    // Pricing
    section_pricing: 'Service Catalog',
    section_pricing_sub: 'Transparent pricing for all services',
    residential: 'Residential',
    commercial: 'Commercial',
    per: 'per',
    starting_from: 'Starting from',
    // Contact
    section_contact: 'Contact Us',
    section_contact_sub: 'Get in touch for a free consultation',
    contact_name: 'Your Name',
    contact_email: 'Email Address',
    contact_phone: 'Phone Number',
    contact_subject: 'Subject',
    contact_message: 'Message',
    contact_send: 'Send Message',
    // Auth
    customer_portal: 'Customer Portal',
    sign_in: 'Sign In',
    sign_up: 'Sign Up',
    sign_in_subtitle: 'Sign in to your account',
    or_continue: 'or',
    sign_in_google: 'Sign in with Google',
    login_with_phone: 'Sign in with Phone',
    login_with_email: 'Sign in with Email',
    send_code: 'Send Code',
    verify_code: 'Verify Code',
    otp_sent: 'Code sent via SMS & email to',
    enter_otp: 'Enter 6-digit code',
    phone_login_hint: 'Only existing customers can sign in with their phone number.',
    change_phone: 'Change number',
    signed_col: 'Signed',
    admin_emails: 'Email Analytics',
    admin_delivery: 'Delivery Status',
    emails_total: 'Total Emails',
    emails_sent: 'Sent',
    emails_failed: 'Failed',
    emails_last30: 'Last 30 Days',
    recent_emails: 'Recent Emails',
    email_to: 'Recipient',
    email_subject: 'Subject',
    email_status: 'Status',
    email_date: 'Date',
    no_emails: 'No emails logged yet.',
    stats_projects_label: 'Projects Completed',
    stats_years_label: 'Years of Experience',
    stats_emergency_label: 'Emergency Service',
    before_after_title: 'Our Work Speaks for Itself',
    before_after_sub: 'Real transformations from recent projects across NYC & Connecticut',
    before_label: 'Before',
    after_label: 'After',
    bp_title: 'Blueprint Reader',
    bp_upload_hint: 'Click or drag a blueprint image here',
    bp_context_placeholder: 'Optional context for the AI (e.g. "2-family house, full rewire, include CCTV")',
    bp_analyze: 'Analyze with AI',
    bp_analyzing: 'Analyzing blueprint...',
    bp_analyzing_note: 'This can take 20-60 seconds for detailed plans.',
    bp_analysis_done: 'Analysis complete! Review and edit the items below.',
    bp_empty: 'Upload a blueprint and click "Analyze with AI" to get a full electrical takeoff: outlets, switches, lights, wiring feet, prices - everything editable.',
    bp_item: 'Item', bp_category: 'Category', bp_qty: 'Qty', bp_unit: 'Unit', bp_price: 'Unit Price', bp_total: 'Total',
    bp_add_item: 'Add item',
    bp_grand_total: 'Grand Total',
    bp_notes: 'AI Notes & Code Requirements',
    bp_save: 'Save',
    bp_saved: 'Analysis saved.',
    bp_send_email: 'Send by Email',
    bp_email_sent: 'Email sent with PDF attached!',
    bp_saved_list: 'Saved analyses',
    bp_no_saved: 'No saved analyses yet.',
    bp_confirm_delete: 'Delete this analysis?',
    bp_deleted: 'Deleted.',
    bp_confidence: 'Confidence',
    bp_image_only: 'Please upload an image file (PNG/JPG). For PDF plans, export or screenshot the page as an image first.',
    sign_up_subtitle: 'Create your account',
    email: 'Email Address',
    password: 'Password',
    full_name: 'Full Name',
    phone: 'Phone Number',
    company: 'Company (Optional)',
    no_account: "Don't have an account? Sign Up",
    has_account: 'Already have an account? Sign In',
    get_quote_no_account: 'Get Quote — No Account Needed',
    get_quote_sub: 'View our services and pricing without creating an account',
    // Staff
    staff_portal: 'Staff Portal',
    staff_subtitle: 'Authorized personnel only',
    // Quote Page
    quote_title: 'Get a Quote',
    quote_select_services: 'Select Services',
    quote_select_sub: 'Click on services you need to get a quote',
    quote_your_quote: 'Your Quote',
    quote_select_from_list: 'Select services from the list',
    quote_your_info: 'Your Information',
    quote_your_name: 'Your name *',
    quote_notes: 'Additional notes...',
    quote_project_name: 'Project name',
    quote_send: 'Send Quote',
    quote_services: 'services',
    quote_sent_title: 'Quote Submitted!',
    quote_sent_sub: "We'll contact you within 24 hours with full pricing and details.",
    quote_create_account: 'Create Account',
    quote_go_back: 'Go Back',
    quote_after_sub: 'After submitting, you can create an account to track progress',
    login_or_register: 'Login / Register',
    // Admin
    admin_dashboard: 'Dashboard',
    admin_requests: 'All Requests',
    admin_customers: 'Customers',
    admin_technicians: 'Technicians',
    admin_invoices: 'Invoices',
    admin_gallery: 'Gallery',
    admin_tracking: 'Time Management',
    admin_payroll: 'Payroll',
    admin_blueprint: 'Blueprints',
    admin_site_content: 'Site Content',
    admin_settings: 'Settings',
    admin_invoice_creator: 'Invoice Creator',
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    submit: 'Submit',
    close: 'Close',
    confirm: 'Confirm',
    actions: 'Actions',
    requests: 'Requests',
    total_count: 'total',
    technicians: 'Technicians',
    status: 'Status',
    price: 'Price',
    name: 'Name',
    address: 'Address',
    date: 'Date',
    total: 'Total',
    notes: 'Notes',
    // Customer Dashboard
    my_requests: 'My Requests',
    new_request: 'New Request',
    my_invoices: 'My Invoices',
    blueprint_builder: 'Blueprint Builder',
    // Technician
    tech_dashboard: 'Dashboard',
    tech_jobs: 'My Jobs',
    clock_in: 'Clock In',
    clock_out: 'Clock Out',
    on_break: 'On Break',
    start_break: 'Start Break',
    end_break: 'End Break',
    report_required: 'Report Required',
    report_required_sub: '4 hours have passed without a report. Submit your update with text and photo.',
    report_now: 'Report Now',
    report_early: 'Report Early',
    next_report_in: 'Next report in',
    report_progress: 'Progress Report (4-Hour)',
    report_text_photo: 'Text + Photo required',
    select_job: 'Select job',
    what_did_you_do: 'What did you do?',
    describe_work: 'Describe work done in the last 4 hours...',
    work_photo_required: 'Work photo (required)',
    click_to_upload: 'Click to upload',
    send_report: 'Send Report',
    report_mandatory: 'This report is mandatory. Please complete before continuing work.',
    assigned: 'Assigned',
    in_progress: 'In Progress',
    completed: 'Completed',
    // Requests Admin
    all_requests: 'All Requests',
    assign: 'Assign',
    assign_technician: 'Assign Technician',
    set_price: 'Set Price',
    edit_price: 'Edit Price',
    change_status: 'Change Status',
    unassigned: 'Unassigned',
    pending: 'Pending',
    cancelled: 'Cancelled',
    ticket: 'Ticket',
    customer: 'Customer',
    service: 'Service',
    technician: 'Technician',
    save_changes: 'Save Changes',
    // Customers Admin
    customers_title: 'Customers',
    customers_registered: 'registered customers',
    search_customers: 'Search customers (name, email, phone, company)...',
    edit_customer: 'Edit Customer',
    reset_password: 'Password',
    change_password: 'Change Password',
    new_password: 'New Password',
    no_customers: 'No customers registered yet.',
    no_results: 'No customers found with this search.',
    confirm_delete_customer: 'Are you sure you want to delete customer',
    action_irreversible: 'This action cannot be undone.',
    // Gallery Admin
    gallery_title: 'Gallery',
    photos: 'photos',
    add_photo: 'Add Photo',
    all: 'All',
    service_type: 'Service Type',
    photo_title: 'Photo Title',
    description: 'Description (optional)',
    edit_photo: 'Edit Photo',
    add_to_gallery: 'Add to Gallery',
    confirm_delete_photo: 'Are you sure you want to delete this photo?',
    no_gallery: 'No gallery photos yet. Add your first photo!',
    upload_files: 'JPG, PNG, PDF, HEIC, WebP (max 25MB)',
    // Invoices
    invoices_title: 'Invoices',
    create_invoice: 'Create Invoice',
    billing: 'BILLING',
    invoice_num: 'INVOICE #',
    amount: 'AMOUNT',
    download_pdf: 'PDF',
    send_invoice: 'Send',
    confirm_delete_invoice: 'Are you sure you want to delete invoice',
    no_invoices: 'No invoices yet.',
    // Live Tracking
    live_map: 'LIVE MAP',
    last_update: 'Last update',
    active: 'active',
    no_techs_working: 'No technicians currently working',
    no_techs_working_sub: 'When a technician clocks in, their live location will appear here',
    working: 'Working',
    lunch_break: 'Lunch Break',
    started: 'Started',
    duration: 'Duration',
    gps_points: 'GPS points recorded',
    google_maps: 'Google Maps',
    // Footer
    footer_rights: 'All rights reserved.',
    footer_licensed: '',
    footer_emergency: '24/7 Emergency Service',
    // Admin Technicians
    tech_page_title: 'Technicians',
    tech_add_btn: 'Add Technician',
    tech_phone: 'Phone',
    tech_rate: 'Rate',
    tech_rate_save: 'Save',
    tech_rate_edit: 'Edit',
    tech_actions_edit: 'Edit',
    tech_actions_password: 'Password',
    tech_actions_delete: 'Delete',
    tech_empty: 'No technicians yet.',
    tech_modal_add: 'Add Technician',
    tech_modal_add_hint: 'Password auto-generated and sent via email.',
    tech_field_name: 'Full Name',
    tech_field_email: 'Email',
    tech_field_phone: 'Phone',
    tech_create_submit: 'Create & Send Credentials',
    tech_modal_edit: 'Edit Technician',
    tech_field_email_locked: 'Email (locked)',
    tech_field_address: 'Address',
    tech_employment_type: 'EMPLOYMENT TYPE',
    tech_profile_photo: 'PROFILE PHOTO (admin only)',
    tech_uploading: 'Uploading...',
    tech_save_changes: 'Save Changes',
    tech_modal_password: 'Change Password',
    tech_new_password: 'New Password',
    // Admin Gallery
    gal_page_title: 'Gallery Management',
    gal_subtitle: 'Manage photos shown to customers',
    gal_upload_btn: 'Upload Photo',
    gal_uploading: 'Uploading...',
    gal_category: 'Category',
    gal_all: 'All',
    gal_title_field: 'Title',
    gal_description: 'Description',
    gal_property_type: 'Property Type',
    gal_residential: 'Residential',
    gal_commercial: 'Commercial',
    gal_select_file: 'Select Image',
    gal_no_photos: 'No photos yet. Upload your first photo!',
    gal_delete_confirm: 'Delete this photo?',
    gal_modal_upload: 'Upload New Photo',
    gal_save: 'Save Photo',
  },
  sq: {
    nav_services: 'Shërbimet',
    nav_gallery: 'Galeria',
    nav_pricing: 'Çmimet',
    nav_contact: 'Kontakti',
    nav_team: 'Ekipi',
    nav_customer_login: 'Hyrja e Klientit',
    nav_get_quote: 'Merr Ofertë',
    hero_title: 'Sisteme Elektrike & Sigurie',
    hero_subtitle: 'Zgjidhje profesionale elektrike, CCTV dhe sigurie për prona rezidenciale dhe komerciale në New York City.',
    hero_cta: 'Merr Vlerësim Falas',
    hero_cta2: 'Shërbimet Tona',
    hero_badge: 'NYC DOB i Çertifikuar',
    hero_trusted: 'Besuar nga 500+ Prona në NYC',
    section_services: 'Shërbimet Tona',
    section_services_sub: 'Zgjidhje të plota elektrike dhe sigurie për çdo nevojë',
    section_gallery: 'Puna Jonë',
    section_gallery_sub: 'Shfletoni portofolin tonë të projekteve të përfunduara',
    view_gallery: 'Shiko Galerinë',
    section_pricing: 'Katalogu i Shërbimeve',
    section_pricing_sub: 'Çmime transparente për të gjitha shërbimet',
    residential: 'Rezidenciale',
    commercial: 'Komerciale',
    per: 'për',
    starting_from: 'Duke filluar nga',
    section_contact: 'Na Kontaktoni',
    section_contact_sub: 'Na kontaktoni për një konsultë falas',
    contact_name: 'Emri juaj',
    contact_email: 'Adresa Email',
    contact_phone: 'Numri i Telefonit',
    contact_subject: 'Subjekti',
    contact_message: 'Mesazhi',
    contact_send: 'Dërgo Mesazhin',
    customer_portal: 'Portali i Klientit',
    sign_in: 'Kyçu',
    sign_up: 'Regjistrohu',
    sign_in_subtitle: 'Kyçuni në llogarinë tuaj',
    or_continue: 'ose',
    sign_in_google: 'Hyr me Google',
    login_with_phone: 'Hyr me Telefon',
    login_with_email: 'Hyr me Email',
    send_code: 'Dërgo Kodin',
    verify_code: 'Verifiko Kodin',
    otp_sent: 'Kodi u dërgua me SMS dhe email te',
    enter_otp: 'Shkruani kodin 6-shifror',
    phone_login_hint: 'Vetëm klientët ekzistues mund të hyjnë me numrin e telefonit.',
    change_phone: 'Ndrysho numrin',
    signed_col: 'Nënshkruar',
    admin_emails: 'Analitika e Email-eve',
    admin_delivery: 'Statusi i Dërgesave',
    emails_total: 'Email-e Gjithsej',
    emails_sent: 'Dërguar',
    emails_failed: 'Dështuar',
    emails_last30: '30 Ditët e Fundit',
    recent_emails: 'Email-et e Fundit',
    email_to: 'Marrësi',
    email_subject: 'Subjekti',
    email_status: 'Statusi',
    email_date: 'Data',
    no_emails: 'Ende nuk ka email-e të regjistruara.',
    stats_projects_label: 'Projekte të Përfunduara',
    stats_years_label: 'Vite Eksperiencë',
    stats_emergency_label: 'Shërbim Urgjent',
    before_after_title: 'Puna Jonë Flet Vetë',
    before_after_sub: 'Transformime reale nga projektet e fundit në NYC & Connecticut',
    before_label: 'Para',
    after_label: 'Pas',
    sign_up_subtitle: 'Krijoni llogarinë tuaj',
    email: 'Adresa Email',
    password: 'Fjalëkalimi',
    full_name: 'Emri i Plotë',
    phone: 'Numri i Telefonit',
    company: 'Kompania (Opsionale)',
    no_account: 'Nuk keni llogari? Regjistrohuni',
    has_account: 'Keni llogari? Kyçuni',
    get_quote_no_account: 'Merr Ofertë — Pa Llogari',
    get_quote_sub: 'Shikoni shërbimet dhe çmimet tona pa krijuar llogari',
    staff_portal: 'Portali i Stafit',
    staff_subtitle: 'Vetëm personeli i autorizuar',
    quote_title: 'Merr Ofertë',
    quote_select_services: 'Zgjidhni Shërbimet',
    quote_select_sub: 'Shtypni mbi shërbimet që ju nevojiten për të marrë ofertë',
    quote_your_quote: 'Oferta Juaj',
    quote_select_from_list: 'Zgjidhni shërbime nga lista',
    quote_your_info: 'Informacioni Juaj',
    quote_your_name: 'Emri juaj *',
    quote_notes: 'Shënime shtesë...',
    quote_project_name: 'Emri i projektit',
    quote_send: 'Dërgo Ofertën',
    quote_services: 'shërbime',
    quote_sent_title: 'Oferta u Dërgua!',
    quote_sent_sub: 'Do t\'ju kontaktojmë brenda 24 orëve me çmimet dhe detajet e plota.',
    quote_create_account: 'Krijoni Llogari',
    quote_go_back: 'Kthehu',
    quote_after_sub: 'Pas dërgimit, mund të krijoni llogari për të ndjekur progresin',
    login_or_register: 'Kyçu / Regjistrohu',
    admin_dashboard: 'Paneli',
    admin_requests: 'Të Gjitha Kërkesat',
    admin_customers: 'Klientët',
    admin_technicians: 'Teknikët',
    admin_invoices: 'Faturat',
    admin_gallery: 'Galeria',
    admin_tracking: 'Menaxhimi i Kohës',
    admin_payroll: 'Paga',
    admin_blueprint: 'Blueprints',
    admin_site_content: 'Përmbajtja',
    admin_settings: 'Cilësimet',
    admin_invoice_creator: 'Krijuesi i Faturave',
    save: 'Ruaj',
    cancel: 'Anulo',
    delete: 'Fshi',
    edit: 'Edito',
    add: 'Shto',
    search: 'Kërko',
    loading: 'Duke ngarkuar...',
    submit: 'Dërgo',
    close: 'Mbyll',
    confirm: 'Konfirmo',
    actions: 'Veprime',
    requests: 'Kërkesat',
    total_count: 'gjithsej',
    technicians: 'Teknikët',
    status: 'Statusi',
    price: 'Çmimi',
    name: 'Emri',
    address: 'Adresa',
    date: 'Data',
    total: 'Totali',
    notes: 'Shënime',
    my_requests: 'Kërkesat e Mia',
    new_request: 'Kërkesë e Re',
    my_invoices: 'Faturat e Mia',
    blueprint_builder: 'Blueprint Builder',
    tech_dashboard: 'Paneli',
    tech_jobs: 'Punët e Mia',
    clock_in: 'Fillo Punën',
    clock_out: 'Mbaro Punën',
    on_break: 'Në Pushim',
    start_break: 'Fillo Pushimin',
    end_break: 'Mbaro Pushimin',
    report_required: 'Raportim i Detyrueshëm',
    report_required_sub: 'Kanë kaluar 4 orë pa raportim. Dërgoni përditësimin tuaj me tekst dhe foto.',
    report_now: 'Raporto Tani',
    report_early: 'Raporto Herët',
    next_report_in: 'Raporti tjetër për',
    report_progress: 'Raporti i Progresit (4-Orësh)',
    report_text_photo: 'Tekst + Foto të detyrueshme',
    select_job: 'Zgjidhni punën',
    what_did_you_do: 'Çfarë keni bërë?',
    describe_work: 'Përshkruani punën e bërë në 4 orët e fundit...',
    work_photo_required: 'Foto e punës (e detyrueshme)',
    click_to_upload: 'Shtypni për foto',
    send_report: 'Dërgo Raportin',
    report_mandatory: 'Ky raportim është i detyrueshëm. Ju lutem plotësoni para se të vazhdoni punën.',
    assigned: 'I Caktuar',
    in_progress: 'Në Progres',
    completed: 'I Përfunduar',
    all_requests: 'Të Gjitha Kërkesat',
    assign: 'Cakto',
    assign_technician: 'Cakto Teknikun',
    set_price: 'Vendos Çmim',
    edit_price: 'Edito Çmim',
    change_status: 'Ndrysho Status',
    unassigned: 'Pa caktuar',
    pending: 'Në Pritje',
    cancelled: 'I Anuluar',
    ticket: 'Ticket',
    customer: 'Klienti',
    service: 'Shërbimi',
    technician: 'Tekniku',
    save_changes: 'Ruaj Ndryshimet',
    customers_title: 'Klientët',
    customers_registered: 'klientë të regjistruar',
    search_customers: 'Kërko klientë (emër, email, telefon, kompani)...',
    edit_customer: 'Edito Klientin',
    reset_password: 'Fjalëkalim',
    change_password: 'Ndrysho Fjalëkalimin',
    new_password: 'Fjalëkalimi i ri',
    no_customers: 'Asnjë klient i regjistruar ende.',
    no_results: 'Asnjë klient nuk u gjet me këtë kërkim.',
    confirm_delete_customer: 'A jeni i sigurt që doni të fshini klientin',
    action_irreversible: 'Ky veprim nuk mund të kthehet.',
    gallery_title: 'Galeria',
    photos: 'foto',
    add_photo: 'Shto Foto',
    all: 'Të Gjitha',
    service_type: 'Lloji i shërbimit',
    photo_title: 'Titulli i fotos',
    description: 'Përshkrimi (opsional)',
    edit_photo: 'Edito Foton',
    add_to_gallery: 'Shto Foto',
    confirm_delete_photo: 'A jeni i sigurt që doni ta fshini këtë foto?',
    no_gallery: 'Asnjë foto në galeri. Shtoni foton tuaj të parë!',
    upload_files: 'JPG, PNG, PDF, HEIC, WebP (max 25MB)',
    invoices_title: 'Faturat',
    create_invoice: 'Krijo Faturë',
    billing: 'FATURIM',
    invoice_num: 'FATURA #',
    amount: 'SHUMA',
    download_pdf: 'PDF',
    send_invoice: 'Dërgo',
    confirm_delete_invoice: 'A jeni i sigurt që doni të fshini faturën',
    no_invoices: 'Asnjë faturë ende.',
    live_map: 'HARTA LIVE',
    last_update: 'Përditësimi i fundit',
    active: 'aktiv',
    no_techs_working: 'Asnjë teknik nuk është duke punuar aktualisht',
    no_techs_working_sub: 'Kur një teknik fillon punën, vendndodhja e tij do të shfaqet këtu në kohë reale',
    working: 'Duke Punuar',
    lunch_break: 'Pushim Dreke',
    started: 'Filloi',
    duration: 'Kohëzgjatja',
    gps_points: 'Pika GPS të regjistruara',
    google_maps: 'Google Maps',
    footer_rights: 'Të gjitha të drejtat e rezervuara.',
    footer_licensed: 'I Licencuar & I Siguruar',
    footer_emergency: 'Shërbim Emergjent 24/7',
    // Admin Technicians (sq)
    tech_page_title: 'Teknikët',
    tech_add_btn: 'Shto Teknik',
    tech_phone: 'Telefon',
    tech_rate: 'Tarifa',
    tech_rate_save: 'Ruaj',
    tech_rate_edit: 'Ndrysho',
    tech_actions_edit: 'Modifiko',
    tech_actions_password: 'Fjalëkalim',
    tech_actions_delete: 'Fshi',
    tech_empty: 'Asnjë teknik ende.',
    tech_modal_add: 'Shto Teknik',
    tech_modal_add_hint: 'Fjalëkalimi gjenerohet automatikisht dhe dërgohet me email.',
    tech_field_name: 'Emri i Plotë',
    tech_field_email: 'Email',
    tech_field_phone: 'Telefon',
    tech_create_submit: 'Krijo & Dërgo Kredencialet',
    tech_modal_edit: 'Modifiko Teknikun',
    tech_field_email_locked: 'Email (i bllokuar)',
    tech_field_address: 'Adresa',
    tech_employment_type: 'TIPI I PUNËSIMIT',
    tech_profile_photo: 'FOTO PROFILI (vetëm admin)',
    tech_uploading: 'Duke ngarkuar...',
    tech_save_changes: 'Ruaj Ndryshimet',
    tech_modal_password: 'Ndrysho Fjalëkalimin',
    tech_new_password: 'Fjalëkalim i Ri',
    // Admin Gallery (sq)
    gal_page_title: 'Menaxhimi i Galerisë',
    gal_subtitle: 'Menaxhoni fotot që u shfaqen klientëve',
    gal_upload_btn: 'Ngarko Foto',
    gal_uploading: 'Duke ngarkuar...',
    gal_category: 'Kategoria',
    gal_all: 'Të Gjitha',
    gal_title_field: 'Titulli',
    gal_description: 'Përshkrimi',
    gal_property_type: 'Tipi i Pronës',
    gal_residential: 'Banesë',
    gal_commercial: 'Tregtar',
    gal_select_file: 'Zgjidh Imazhin',
    gal_no_photos: 'Asnjë foto ende. Ngarko foton tënde të parë!',
    gal_delete_confirm: 'Të fshihet kjo foto?',
    gal_modal_upload: 'Ngarko Foto të Re',
    gal_save: 'Ruaj Foton',
  },
  es: {
    nav_services: 'Servicios',
    nav_gallery: 'Galería',
    nav_pricing: 'Precios',
    nav_contact: 'Contacto',
    nav_team: 'Equipo',
    nav_customer_login: 'Inicio de Sesión',
    nav_get_quote: 'Cotización',
    hero_title: 'Sistemas Eléctricos y de Seguridad',
    hero_subtitle: 'Soluciones profesionales eléctricas, CCTV y de seguridad para propiedades residenciales y comerciales en la ciudad de Nueva York.',
    hero_cta: 'Estimado Gratis',
    hero_cta2: 'Nuestros Servicios',
    hero_badge: 'Certificado NYC DOB',
    hero_trusted: 'Confiado por 500+ Propiedades en NYC',
    section_services: 'Nuestros Servicios',
    section_services_sub: 'Soluciones eléctricas y de seguridad completas para cada necesidad',
    section_gallery: 'Nuestro Trabajo',
    section_gallery_sub: 'Explore nuestro portafolio de proyectos completados',
    view_gallery: 'Ver Galería',
    section_pricing: 'Catálogo de Servicios',
    section_pricing_sub: 'Precios transparentes para todos los servicios',
    residential: 'Residencial',
    commercial: 'Comercial',
    per: 'por',
    starting_from: 'Desde',
    section_contact: 'Contáctenos',
    section_contact_sub: 'Comuníquese para una consulta gratuita',
    contact_name: 'Su Nombre',
    contact_email: 'Correo Electrónico',
    contact_phone: 'Número de Teléfono',
    contact_subject: 'Asunto',
    contact_message: 'Mensaje',
    contact_send: 'Enviar Mensaje',
    customer_portal: 'Portal del Cliente',
    sign_in: 'Iniciar Sesión',
    sign_up: 'Registrarse',
    sign_in_subtitle: 'Inicie sesión en su cuenta',
    or_continue: 'o',
    sign_in_google: 'Iniciar sesión con Google',
    login_with_phone: 'Iniciar con Teléfono',
    login_with_email: 'Iniciar con Correo',
    send_code: 'Enviar Código',
    verify_code: 'Verificar Código',
    otp_sent: 'Código enviado por SMS y correo a',
    enter_otp: 'Ingrese el código de 6 dígitos',
    phone_login_hint: 'Solo los clientes existentes pueden iniciar sesión con su teléfono.',
    change_phone: 'Cambiar número',
    signed_col: 'Firmado',
    admin_emails: 'Analítica de Correos',
    admin_delivery: 'Estado de Envíos',
    emails_total: 'Correos Totales',
    emails_sent: 'Enviados',
    emails_failed: 'Fallidos',
    emails_last30: 'Últimos 30 Días',
    recent_emails: 'Correos Recientes',
    email_to: 'Destinatario',
    email_subject: 'Asunto',
    email_status: 'Estado',
    email_date: 'Fecha',
    no_emails: 'Aún no hay correos registrados.',
    stats_projects_label: 'Proyectos Completados',
    stats_years_label: 'Años de Experiencia',
    stats_emergency_label: 'Servicio de Emergencia',
    before_after_title: 'Nuestro Trabajo Habla por Sí Mismo',
    before_after_sub: 'Transformaciones reales de proyectos recientes en NYC y Connecticut',
    before_label: 'Antes',
    after_label: 'Después',
    bp_title: 'Lector de Planos',
    bp_upload_hint: 'Haga clic o arrastre una imagen del plano aquí',
    bp_context_placeholder: 'Contexto opcional para la IA (ej. "casa de 2 familias, recableado completo, incluir CCTV")',
    bp_analyze: 'Analizar con IA',
    bp_analyzing: 'Analizando el plano...',
    bp_analyzing_note: 'Puede tardar 20-60 segundos para planos detallados.',
    bp_analysis_done: '¡Análisis completo! Revise y edite los artículos abajo.',
    bp_empty: 'Suba un plano y haga clic en "Analizar con IA" para un desglose eléctrico completo: enchufes, interruptores, luces, pies de cable, precios - todo editable.',
    bp_item: 'Artículo', bp_category: 'Categoría', bp_qty: 'Cant.', bp_unit: 'Unidad', bp_price: 'Precio', bp_total: 'Total',
    bp_add_item: 'Añadir artículo',
    bp_grand_total: 'Total General',
    bp_notes: 'Notas IA y Requisitos de Código',
    bp_save: 'Guardar',
    bp_saved: 'Análisis guardado.',
    bp_send_email: 'Enviar por Correo',
    bp_email_sent: '¡Correo enviado con PDF adjunto!',
    bp_saved_list: 'Análisis guardados',
    bp_no_saved: 'Aún no hay análisis guardados.',
    bp_confirm_delete: '¿Eliminar este análisis?',
    bp_deleted: 'Eliminado.',
    bp_confidence: 'Confianza',
    bp_image_only: 'Suba un archivo de imagen (PNG/JPG). Para planos PDF, exporte o capture la página como imagen primero.',
    sign_up_subtitle: 'Cree su cuenta',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    full_name: 'Nombre Completo',
    phone: 'Número de Teléfono',
    company: 'Empresa (Opcional)',
    no_account: '¿No tiene cuenta? Regístrese',
    has_account: '¿Ya tiene cuenta? Inicie Sesión',
    get_quote_no_account: 'Cotización — Sin Cuenta',
    get_quote_sub: 'Vea nuestros servicios y precios sin crear una cuenta',
    staff_portal: 'Portal del Personal',
    staff_subtitle: 'Solo personal autorizado',
    quote_title: 'Obtener Cotización',
    quote_select_services: 'Seleccionar Servicios',
    quote_select_sub: 'Haga clic en los servicios que necesita para obtener una cotización',
    quote_your_quote: 'Su Cotización',
    quote_select_from_list: 'Seleccione servicios de la lista',
    quote_your_info: 'Su Información',
    quote_your_name: 'Su nombre *',
    quote_notes: 'Notas adicionales...',
    quote_project_name: 'Nombre del proyecto',
    quote_send: 'Enviar Cotización',
    quote_services: 'servicios',
    quote_sent_title: '¡Cotización Enviada!',
    quote_sent_sub: 'Le contactaremos dentro de 24 horas con precios y detalles completos.',
    quote_create_account: 'Crear Cuenta',
    quote_go_back: 'Volver',
    quote_after_sub: 'Después de enviar, puede crear una cuenta para seguir el progreso',
    login_or_register: 'Iniciar Sesión / Registrarse',
    admin_dashboard: 'Panel',
    admin_requests: 'Todas las Solicitudes',
    admin_customers: 'Clientes',
    admin_technicians: 'Técnicos',
    admin_invoices: 'Facturas',
    admin_gallery: 'Galería',
    admin_tracking: 'Gestión de Tiempo',
    admin_payroll: 'Nómina',
    admin_blueprint: 'Planos',
    admin_site_content: 'Contenido',
    admin_settings: 'Configuración',
    admin_invoice_creator: 'Creador de Facturas',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    loading: 'Cargando...',
    submit: 'Enviar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    actions: 'Acciones',
    requests: 'Solicitudes',
    total_count: 'total',
    technicians: 'Técnicos',
    status: 'Estado',
    price: 'Precio',
    name: 'Nombre',
    address: 'Dirección',
    date: 'Fecha',
    total: 'Total',
    notes: 'Notas',
    my_requests: 'Mis Solicitudes',
    new_request: 'Nueva Solicitud',
    my_invoices: 'Mis Facturas',
    blueprint_builder: 'Constructor de Planos',
    tech_dashboard: 'Panel',
    tech_jobs: 'Mis Trabajos',
    clock_in: 'Entrada',
    clock_out: 'Salida',
    on_break: 'En Descanso',
    start_break: 'Iniciar Descanso',
    end_break: 'Terminar Descanso',
    report_required: 'Reporte Requerido',
    report_required_sub: 'Han pasado 4 horas sin reporte. Envíe su actualización con texto y foto.',
    report_now: 'Reportar Ahora',
    report_early: 'Reportar Temprano',
    next_report_in: 'Próximo reporte en',
    report_progress: 'Reporte de Progreso (4 Horas)',
    report_text_photo: 'Texto + Foto requeridos',
    select_job: 'Seleccionar trabajo',
    what_did_you_do: '¿Qué hizo?',
    describe_work: 'Describa el trabajo realizado en las últimas 4 horas...',
    work_photo_required: 'Foto del trabajo (requerida)',
    click_to_upload: 'Clic para subir',
    send_report: 'Enviar Reporte',
    report_mandatory: 'Este reporte es obligatorio. Complete antes de continuar.',
    assigned: 'Asignado',
    in_progress: 'En Progreso',
    completed: 'Completado',
    all_requests: 'Todas las Solicitudes',
    assign: 'Asignar',
    assign_technician: 'Asignar Técnico',
    set_price: 'Fijar Precio',
    edit_price: 'Editar Precio',
    change_status: 'Cambiar Estado',
    unassigned: 'Sin asignar',
    pending: 'Pendiente',
    cancelled: 'Cancelado',
    ticket: 'Ticket',
    customer: 'Cliente',
    service: 'Servicio',
    technician: 'Técnico',
    save_changes: 'Guardar Cambios',
    customers_title: 'Clientes',
    customers_registered: 'clientes registrados',
    search_customers: 'Buscar clientes (nombre, correo, teléfono, empresa)...',
    edit_customer: 'Editar Cliente',
    reset_password: 'Contraseña',
    change_password: 'Cambiar Contraseña',
    new_password: 'Nueva Contraseña',
    no_customers: 'Sin clientes registrados aún.',
    no_results: 'Ningún cliente encontrado.',
    confirm_delete_customer: '¿Está seguro de eliminar al cliente',
    action_irreversible: 'Esta acción no se puede deshacer.',
    gallery_title: 'Galería',
    photos: 'fotos',
    add_photo: 'Agregar Foto',
    all: 'Todas',
    service_type: 'Tipo de servicio',
    photo_title: 'Título de la foto',
    description: 'Descripción (opcional)',
    edit_photo: 'Editar Foto',
    add_to_gallery: 'Agregar Foto',
    confirm_delete_photo: '¿Está seguro de eliminar esta foto?',
    no_gallery: '¡Sin fotos en la galería. Agregue su primera foto!',
    upload_files: 'JPG, PNG, PDF, HEIC, WebP (máx 25MB)',
    invoices_title: 'Facturas',
    create_invoice: 'Crear Factura',
    billing: 'FACTURACIÓN',
    invoice_num: 'FACTURA #',
    amount: 'MONTO',
    download_pdf: 'PDF',
    send_invoice: 'Enviar',
    confirm_delete_invoice: '¿Está seguro de eliminar la factura',
    no_invoices: 'Sin facturas aún.',
    live_map: 'MAPA EN VIVO',
    last_update: 'Última actualización',
    active: 'activo',
    no_techs_working: 'Ningún técnico trabajando actualmente',
    no_techs_working_sub: 'Cuando un técnico inicie, su ubicación aparecerá aquí en tiempo real',
    working: 'Trabajando',
    lunch_break: 'Descanso',
    started: 'Inició',
    duration: 'Duración',
    gps_points: 'Puntos GPS registrados',
    google_maps: 'Google Maps',
    footer_rights: 'Todos los derechos reservados.',
    footer_licensed: 'Licenciado y Asegurado',
    footer_emergency: 'Servicio de Emergencia 24/7',
  }
};

const FLAGS = {
  en: '🇺🇸',
  sq: '🇦🇱',
  es: '🇪🇸'
};

const LANG_NAMES = {
  en: 'English',
  sq: 'Shqip',
  es: 'Español'
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('bellaja_lang') || 'en');

  useEffect(() => {
    localStorage.setItem('bellaja_lang', lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, t, FLAGS, LANG_NAMES }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);

export { FLAGS, LANG_NAMES };
export default translations;
